export default __webpack_public_path__ + "static/media/uppe_device-min.d71f02cf.png";